import { waLink, WA_DEFAULT_MSG } from "@/lib/wa";
import { WhatsAppIcon } from "./Shared";

export const FloatingWa = () => (
    <a
        href={waLink(WA_DEFAULT_MSG)}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat WhatsApp TechFlaze"
        data-testid="floating-wa-button"
        className="wa-float-pulse fixed bottom-6 right-6 z-50 hidden h-14 w-14 items-center justify-center rounded-full bg-green-500 text-white shadow-xl transition-[transform,background-color] duration-200 hover:scale-110 hover:bg-green-600 md:bottom-8 md:right-8 md:flex"
    >
        <WhatsAppIcon className="h-7 w-7" />
    </a>
);
